import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router';

import history from './history';

import { App } from './app';

import { SiteConfig } from './config';
import { injectBsp } from './utils/bsp';

import gql from 'graphql-tag';
import { ApolloProvider, useQuery } from '@apollo/react-hooks';
import { createApolloClient } from './shared/services/Apollo';
import { getAlgoliaSearchKeyQuery } from './generated/graphql';

injectBsp();

const GET_ALGOLIASEARCHKEY = gql`
    query getAlgoliaSearchKey {
        algoliaSearchKey {
            key
            timeToLive
        }
    }
`;

const Search = () => {
    const { loading, error } = useQuery<getAlgoliaSearchKeyQuery>(GET_ALGOLIASEARCHKEY);

    if (!loading && !error) {
        return <App />;
    }

    return null;
};

ReactDOM.render(
    <>
        <ApolloProvider client={createApolloClient(SiteConfig.graphqlEndpoint)}>
            <Router history={history}>
                <Search />
            </Router>
        </ApolloProvider>
    </>,

    document.getElementById('root'),
);
